import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../../common/global-constants";
import { BOOdontologyPatientBackground } from "../../models/odo/BOOdontologyPatientBackground.model";
import { BOOdontologyRadiologicExamPatient } from "../../models/odo/BOOdontologyRadiologicExamPatient.model";

@Injectable({
  providedIn: 'root'
}

)
export class OdontologyRadiologicExamPatientService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/OdontologyRadiologicExamPatient';

    constructor(private http:HttpClient){}
// #region First

    getAll():Observable<BOOdontologyRadiologicExamPatient[]>{
        return this.http.get<BOOdontologyRadiologicExamPatient[]>(this.myAppUrl + this.myApiUrl+'/getAll');
    }


    saveOrUpdateOdontologyRadiologicExamPatient(backgrounds:BOOdontologyRadiologicExamPatient[]):Observable<BOOdontologyRadiologicExamPatient[]>
    {
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(backgrounds);
        return this.http.post<BOOdontologyRadiologicExamPatient[]>(this.myAppUrl + this.myApiUrl + '/saveOrUpdateOdontologyRadiologicExamPatient',body,httpOptions);
    }


    getOdontologyHistoriesByClinicId(clinicHistoryId:number):Observable<BOOdontologyRadiologicExamPatient[]>{
        return this.http.get<BOOdontologyRadiologicExamPatient[]>(this.myAppUrl + this.myApiUrl + '/getOdontologyHistoriesByClinicId/' + clinicHistoryId);
    }

// #endregion First

//#region Single
  getAllByPatientId(patientId:number):Observable<BOOdontologyRadiologicExamPatient[]>{
      return this.http.get<BOOdontologyRadiologicExamPatient[]>(this.myAppUrl + this.myApiUrl+'/getAllByPatientId/'+patientId);
  }


  createOrUpdateOdontologyRadiologicExamPatientSingle(patientId:number, radiology:BOOdontologyRadiologicExamPatient):Observable<BOOdontologyRadiologicExamPatient>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(radiology);
      return this.http.post<BOOdontologyRadiologicExamPatient>(this.myAppUrl + this.myApiUrl + '/createOrUpdateOdontologyRadiologicExamPatientSingle/' + patientId,body,httpOptions);
  }

  deleteOdontologyRadiologicExamPatientSingle(id:number):Observable<BOOdontologyRadiologicExamPatient>
  {
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOOdontologyRadiologicExamPatient>(this.myAppUrl + this.myApiUrl + '/deleteOdontologyRadiologicExamPatientSingle/' + id,null,httpOptions);
  }


//#endregion Single



}
